import { Component } from '@angular/core';

import { WindowService } from '@public/core';

import { ContentComponent, FooterComponent, HeaderComponent, LayoutComponent } from '@public/core/ui/layout';

import { FooterContentComponent, HeaderContentComponent } from '@naturfond/common';

@Component({
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  imports: [
    ContentComponent,
    FooterComponent,
    HeaderComponent,
    LayoutComponent,
    
    FooterContentComponent,
    HeaderContentComponent,
  ],
})
export class PrivacyPolicyComponent {
  constructor(public windowService: WindowService) {}
}
